import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-validate-with-options-failed',
  templateUrl: './validate-with-options-failed.component.html',
  styleUrls: ['./validate-with-options-failed.component.scss']
})
export class ValidateWithOptionsFailedComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
